import {useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import DrumsMachine from './components/DrumsMachine'; 
import './styles/GeneralStyles.css'
import './AppCajaDeRitmos.css'

const AppCajaDeRitmos = () => {

  useEffect(()=>{
    window.scroll(0,0);
  });

  return(
    <Grid container className="AppCajaDeRitmos" 
      justifyContent="center" alignItems="center"
      >
       <DrumsMachine />
    </Grid>
  );
}

export default AppCajaDeRitmos;